function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { FilterItem } from 'apps/boards/src/dashboards-app/components/global-filter-bar/filter-item';
import { FilterPlaceholder } from 'apps/boards/src/dashboards-app/components/global-filter-bar/filter-placeholder';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { Section } from 'common/components/items-menu/types';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentGlobalFilters } from 'iron/apps/experiments/src/components/hooks/global-filters';
import { useExperimentPageContext } from 'iron/apps/experiments/src/components/context';
import { ChangeEvent } from 'common/components/select/types';
import { InputReact } from 'common/components/input';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { InputSize } from 'common/components/input/types';
import { useExposuresSeriesName, useVariants } from 'iron/apps/experiments/src/components/hooks/metric-results';
import styles from './_filter-bar.module.styl';
export function ExperimentPageSummaryMetricsFilterBar() {
  var _useExposuresSeriesNa;
  const {
    t
  } = useTranslation();
  const metricsSearch = useExperimentsStore(state => state.metricsSearch);
  const setMetricsSearch = useExperimentsStore(state => state.setMetricsSearch);
  const {
    projectId,
    workspaceId,
    userId,
    segmentFilterController
  } = useExperimentPageContext();
  const {
    globalFilters,
    onFiltersChange,
    onVariantsFilterChange
  } = useExperimentGlobalFilters();
  const variants = useVariants();
  const exposuresSeriesName = (_useExposuresSeriesNa = useExposuresSeriesName()) !== null && _useExposuresSeriesNa !== void 0 ? _useExposuresSeriesNa : "";
  const [isFilterPlaceholderOpen, setIsFilterPlaceholderOpen] = React.useState<boolean>(false);
  const [segmentFilterControllerCounter, setSegmentFilterControllerCounter] = React.useState(0);
  const incrementSegmentFilterControllerCounter = React.useCallback(() => {
    setSegmentFilterControllerCounter(prev => prev + 1);
  }, []);
  React.useEffect(() => {
    segmentFilterController === null || segmentFilterController === void 0 || segmentFilterController.subscribe(incrementSegmentFilterControllerCounter);
    return () => {
      segmentFilterController === null || segmentFilterController === void 0 || segmentFilterController.unsubscribe(incrementSegmentFilterControllerCounter);
    };
  }, [segmentFilterController, incrementSegmentFilterControllerCounter]);
  const variantOptions: Section[] = React.useMemo(() => [{
    items: [{
      label: t("experiments.main.metrics.filters.all-variants"),
      value: ""
    }, ...Array.from(variants).map((variant, i) => ({
      label: t("experiments.main.metrics.filters.variant", {
        num: i + 1,
        variant
      }),
      value: variant,
      icon: "chart-color",
      color: segmentFilterController === null || segmentFilterController === void 0 ? void 0 : segmentFilterController.getItemColor(0, "".concat(exposuresSeriesName, ",").concat(variant))
    }))]
  }], [variants, exposuresSeriesName, segmentFilterControllerCounter]);
  const handleSelectVariantFilter = (ev?: ChangeEvent) => {
    var _ev$detail;
    if (ev !== null && ev !== void 0 && (_ev$detail = ev.detail) !== null && _ev$detail !== void 0 && (_ev$detail = _ev$detail.item) !== null && _ev$detail !== void 0 && _ev$detail.value) {
      onVariantsFilterChange(String(ev.detail.item.value));
    } else {
      onVariantsFilterChange(undefined);
    }
  };
  const variantsFilterLabel = globalFilters.variantsFilter ? String(globalFilters.variantsFilter) : t("experiments.main.metrics.filters.all-variants");
  const selectedVariantIcon = React.useMemo(() => globalFilters.variantsFilter ? {
    leftIcon: "chart-color",
    leftIconColor: segmentFilterController === null || segmentFilterController === void 0 ? void 0 : segmentFilterController.getItemColor(0, "".concat(exposuresSeriesName, ",").concat(globalFilters.variantsFilter))
  } : undefined, [globalFilters.variantsFilter, segmentFilterControllerCounter]);
  return <div className={styles.filterBar} data-sentry-component="ExperimentPageSummaryMetricsFilterBar" data-sentry-source-file="_filter-bar.tsx">
      <div className={styles.leftSide}>
        {globalFilters.filters.map((filter, index) => <FilterItem key={"filter-".concat(index)} filter={filter} onChange={newFilter => {
        const newFilters = [...globalFilters.filters];
        newFilters[index] = _objectSpread(_objectSpread({}, newFilter), {}, {
          filterValue: newFilter.activeValue
        });
        onFiltersChange(newFilters);
      }} onClickDelete={() => {
        const newFilters = [...globalFilters.filters];
        newFilters.splice(index, 1);
        onFiltersChange(newFilters);
      }} onClickDuplicate={() => {
        const newFilters = [...globalFilters.filters.slice(0, index), _objectSpread({}, filter), ...globalFilters.filters.slice(index)];
        onFiltersChange(newFilters);
      }} projectId={projectId} workspaceId={workspaceId} userId={userId as number} trackName={"experiment"} />)}
        {isFilterPlaceholderOpen && <FilterPlaceholder onAdd={filter => onFiltersChange([...globalFilters.filters, filter])} onClose={() => setIsFilterPlaceholderOpen(false)} projectId={projectId} workspaceId={workspaceId} userId={userId as number} trackName={"experiment"} />}
        <ButtonReact theme={ButtonTheme.Tertiary} icon='plus' onClick={() => setIsFilterPlaceholderOpen(true)} data-sentry-element="ButtonReact" data-sentry-source-file="_filter-bar.tsx">
          {t("common.filter")}
        </ButtonReact>
      </div>
      <div className={styles.rightSide}>
        {variants.size > 1 && <SelectReact selectedOption={globalFilters.variantsFilter || ""} label={variantsFilterLabel} icon={selectedVariantIcon} theme={SelectTheme.Secondary} alwaysShowCaret menuWidth={-1} onChange={(ev: TODO) => handleSelectVariantFilter(ev)} sections={variantOptions} />}
        <InputReact className={styles.search} icon='search' size={InputSize.Medium} value={metricsSearch} placeholder={t("experiments.main.metrics.filters.search")} onInput={ev => setMetricsSearch(ev.target.value)} data-sentry-element="InputReact" data-sentry-source-file="_filter-bar.tsx" />
      </div>
    </div>;
}